<template>
  <div class="html-tip">
    <header :class="{ open }">
      <h6 class="title">How to fill an HTML field</h6>
      <button
        @click="toggleOpen"
        aria-expanded="open"
        aria-controls="html-tip__content"
        class="toggle-button"
        :class="{ open: open, close: !open }"
      >
        <span class="sr-only">Toggle HTML Tip</span>
      </button>
    </header>
    <Transition name="slide-fade">
      <div v-show="open" class="html-tip__content">
        <h5 class="title">Create a link:</h5>
        <p>
          (e.g. <span class="link">Play Now</span>)
          <span class="red">-></span> &lt;a href="www.google.com"&gt;Play
          Now&lt;/a&gt;
        </p>
        <p>
          ”NOTE”: If you want the link to open a new tab, add [target=”blank”] after
          the href
        </p>

        <h5 class="title">Bold Text:</h5>
        <p>
          (e.g <strong>Bold text</strong>)
          <span class="red">-></span> &lt;strong&gt;Bold text&lt;/strong&gt;
        </p>

        <h5 class="title">Underscore Text:</h5>
        <p>
          (e.g <u>Underscore text</u>)
          <span class="red">-></span> &lt;u&gt;Underscore text&lt;/u&gt;
        </p>

        <h5 class="title">Italic Text:</h5>
        <p>
          (e.g <em>Italic text</em>)
          <span class="red">-></span> &lt;em&gt;Italic text&lt;/em&gt;
        </p>

        <h5 class="title">Break Line:</h5>
        <span class="red">-></span> &lt;br&gt;
        <p>Where you want to break the line</p>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: "HtmlTip",
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped>
.html-tip {
  width: 100%;
  background-color: #f9f8f6;
  border-color: #d5d5d5;
  border-style: solid;
  border-width: 1px 0;
  padding: 0px 20px;
  margin-top: 10px;
}

.html-tip header {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
}

.html-tip header.open {
  border-bottom: 1px solid #d5d5d5;
}

.html-tip__content {
  margin-top: 10px;
  width: 100%;
  overflow: hidden;
  z-index: 1;
}

.title {
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
}

.link {
  color: #2172BF;
}

.red {
  color: #EC1300;
}

.html-tip__content p {
  font-family: Lato;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.toggle-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 24px 24px;
  width: 24px;
  height: 24px;
}

.toggle-button.open {
  background-image: url("circle-minus.svg");
}

.toggle-button.close {
  background-image: url("circle-plus.svg");
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease, height 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
  height: 0;
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  opacity: 1;
  height: auto;
}
</style>
